export type GuideOrder = {
  by: string;
  dir: 'asc' | 'desc';
};

// Colunas das tabelas de guia -> valores aceitos em order_by pela API.
const orderByColumn: Record<string, string> = {
  id: 'id',
  appointment_date: 'appointment_date',
  created_at: 'created_at',
  status: 'status',
  value_marker: 'value_marker',
  value_procedure: 'value_procedure',
  value_discount: 'value_discount',
  value_total: 'value_total',
  formattedPatientName: 'patient_name',
  patientProcedure: 'patient_name',
  formattedDoctorName: 'doctor_name',
  formattedMarkerName: 'marker_name',
};

export function getGuideOrderDirection(column: string, order: GuideOrder | null): 'asc' | 'desc' | null {
  const by = orderByColumn[column];
  return by && order?.by === by ? order.dir : null;
}

export function nextGuideOrder(column: string, current: GuideOrder | null): GuideOrder | null {
  const by = orderByColumn[column];
  if (!by) return null;

  return { by, dir: current?.by === by && current.dir === 'asc' ? 'desc' : 'asc' };
}

export function guideOrderParams(order: GuideOrder | null) {
  return order ? { order_by: order.by, order_dir: order.dir } : {};
}
